
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.004.024A1.134 1.134 0 007.87 1.158v12.96l-3.298-3.297a1.134 1.134 0 00-.854-.33 1.134 1.134 0 00-.746.33 1.134 1.134 0 000 1.601l5.231 5.232a1.134 1.134 0 001.601 0l5.232-5.232a1.134 1.134 0 000-1.6 1.134 1.134 0 00-1.6 0l-3.298 3.296V1.158A1.134 1.134 0 009.004.024z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    